const config = {
  isMenuShown: undefined,
  selectedMenu: "wyjazdy",
  fetchUrl: "./data/",
  layers: [
    {
      id: "airports",
      name: "Lotniska",
      isVisible: true
    },
    {
      id: "routes",
      name: "Trasy lotów",
      isVisible: true
    },
    {
      id: "places",
      name: "Miejsca",
      isVisible: true
    }
  ],
  modes: [
    {
      id: "past",
      name: "Podróże",
      title: "Pokaż na mapie tylko zakończone wyjazdy",
      isSelected: true
    },
    {
      id: "future",
      name: "Plany",
      title: "Pokaż na mapie i w statystykach tylko zaplanowane wyjazdy",
      isSelected: false
    },
    {
      id: "canceled",
      name: "Skasowane loty",
      title: "Pokaż na mapie i w statystykach tylko skasowane odcinki",
      isSelected: false
    }
  ],
  polyline: {
    color: "#b44",
    weight: 1
  },
  // Please align with $smallScreenTreshold of config.scss file
  smallScreenTreshold: 560
};

export default config;
